/* Used for push notifications, cookies and popups. */
import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import Transition from 'react-transition-group/Transition';
import Newsletter from '../Footer/Newsletter';
import Button from '../Elements/Button/Button';
import TrustBox from '../Templates/TrustBox/TrustBox';
import { addEvent, removeEvent, purifier, width, getCookie } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { isRestricted } from '../../utils/restrict';
import { urlify } from '../../utils/string';
import s from './Notification.scss';

class Notification extends Component {
	campaignCycle = false;

	constructor(props) {
		super(props);

		this.notificationInner = React.createRef();
		this.notificationInnerContent = React.createRef();
		this.notificationClose = React.createRef();

		this.state = {
			notificationIndex: 0,
			scrolling: false,
			showVoucher: false,
			showPopup: false,
			copied: false,
			delay: {},
		};
	}

	componentDidMount() {
		const { type, content = [], setup } = this.props;
		let isScrolling = false;
		const notifications = content.filter((n) => {
			if (n.countryRestrict && isRestricted(setup, { selectedCountries: n.countryRestrict })) return false;
			if (n.customRestrict && n.customRestrict !== setup.campaignType) return false;
			if (n.content) {
				const hasContent = n.content.filter((c) => {
					if (c.countryRestrictContent && isRestricted(setup, { selectedCountries: c.countryRestrictContent })) return false;
					if (c.customRestrictContent && c.customRestrictContent !== setup.campaignType) return false;
					if (!c.text && !c.icon) return false;
					return true;
				});
				if (!hasContent) return false;
			}
			if (!n.content && !n.text) return false;
			return true;
		});

		const scrollCampaignNotification = () => {
			if (!this.notificationInnerContent.current || type !== 'campaign') return;
			const innerContentWidth = width(this.notificationInnerContent.current, 'scrollWidth');
			if (!isScrolling && innerContentWidth > (window.innerWidth - 40)) {
				isScrolling = true;
				this.setState({ scrolling: Math.round(innerContentWidth / 400) });
			} else if (isScrolling && innerContentWidth <= (window.innerWidth - 40)) {
				isScrolling = false;
				this.setState({ scrolling: false });
			}
		};

		addEvent(document.body, 'click.notificationClose', (e) => {
			if (this.notificationInner.current && !this.notificationInner.current.contains(e.target) && this.props.type === 'popup' && this.state.showPopup) {
				e.preventDefault();
				e.stopPropagation();
				this.setState({
					showPopup: false,
				});
			}
		});

		notifications.forEach((item) => {
			const notificationName = urlify(item.name);
			if (parseInt(item.delay, 10) >= 0) {
				this.setState((prevState) => ({
					delay: {
						...prevState.delay,
						[notificationName]: false,
					},
				}));
				setTimeout(() => {
					if (window.location.pathname.indexOf('selection') === -1) {
						this.setState((prevState) => ({
							showPopup: true,
							delay: {
								...prevState.delay,
								[notificationName]: true,
							},
						}));
					}
				}, parseInt(item.delay, 10) * 1e3);
			}
		});

		if (notifications && notifications.length > 1 && type === 'campaign') {
			this.campaignCycle = setInterval(() => {
				this.setState((prevState) => ({ notificationIndex: prevState.notificationIndex + 1 }));
			}, 4000);
		}

		addEvent(window, 'resize.notifications', () => {
			window.requestAnimationFrame(scrollCampaignNotification);
		});

		scrollCampaignNotification();
	}

	componentWillUnmount() {
		clearInterval(this.campaignCycle);
		removeEvent(document.body, 'click.notificationClose');
		removeEvent(window, 'resize.notifications');
	}

	removeNotificationHandler = (e) => {
		if (e) e.preventDefault();

		const $notificationElement = this.notificationInner.current;
		const cookieName = $notificationElement.dataset.name;
		const cookieDuration = $notificationElement.dataset.duration;

		let date = new Date();
		date = date.setTime(date.getTime() + (cookieDuration * 1000));

		const expires = `expires=${new Date(date).toGMTString()}; `;

		document.cookie = `${cookieName}=1; ${expires}path=/`;

		// Notify Redux that we have removed the item.
		this.props.notificationRemoved();
		this.props.removeNotification(this.props.type, cookieName);
	}

	togglePopupHandler = () => {
		this.setState((prevState) => ({
			showPopup: !prevState.showPopup,
		}));
	}

	copyToClipboard = (e) => {
		const value = e.currentTarget.value;
		window.navigator.clipboard.writeText(value);
		this.setState({
			copied: true,
		});
	}

	newsletterSubmitHandler = () => {
		this.setState({
			showVoucher: true,
		});
	}

	render() {
		const { type, content, setup } = this.props;
		const { notificationIndex, delay, showVoucher, showPopup, copied, scrolling } = this.state;

		if (!content) return null;

		const notifications = content.filter((n) => {
			if (n.countryRestrict && isRestricted(setup, { selectedCountries: n.countryRestrict })) return false;
			if (n.customRestrict && n.customRestrict !== setup.campaignType) return false;
			if (n.content) {
				const hasContent = n.content.filter((c) => {
					if (c.customRestrictContent && c.customRestrictContent !== setup.campaignType) return false;
					if (c.countryRestrictContent && isRestricted(setup, { selectedCountries: c.countryRestrictContent })) return false;
					if (!c.text && !c.icon) return false;
					return true;
				});
				if (!hasContent) return false;
			}
			if (!n.content && !n.text) return false;
			return true;
		});

		return (
			<div className={[s.notification, s[`notification__${type}`]].join(' ')}>
				{
					notifications.map((item, i) => {
						const notificationName = urlify(item.name);
						const notificationAttributes = {
							style: {},
						};
						const notificationInnerClasses = [s.notification_inner, (item.removeText ? [s.notification_inner__closeText] : null)];
						if (notificationIndex % notifications.length === i) notificationInnerClasses.push(s.notification_inner__selected);
						if (scrolling) {
							notificationInnerClasses.push(s.notification_inner__scrolling);
							notificationInnerClasses.push(s[`notification_inner__scrolling${scrolling}`]);
						}

						if (item.backgroundColor) {
							if (item.backgroundColor.indexOf('#') === 0) notificationAttributes.style.backgroundColor = item.backgroundColor;
							else notificationInnerClasses.push(s[`notification_inner__${item.backgroundColor.toLowerCase()}`]);
						}
						if (item.contentColor) notificationAttributes.style.color = item.contentColor;
						if (Object.keys(notificationAttributes.style).length === 0) delete notificationAttributes.style;

						// Check for cookies which are already set.
						if (item.removable && item.cookieDuration) {
							let cookieIsSet = false;
							notificationInnerClasses.push(s.notification_inner__removable);

							const cookies = typeof document !== 'undefined' ? getCookie(notificationName, true) : JSON.parse((setup?.cookies?.[notificationName] || false));
							if (cookies && cookies !== 1) cookieIsSet = true;

							// Still render notification if from server and cookie not set on page load.
							// This enables us to fade it out.
							if ((cookieIsSet && item.removed !== true) || (item.delay && !delay[notificationName])) return null;

							/*
							const cookies = typeof document !== 'undefined' ? document.cookie : setup.cookies;
							if (typeof cookies === 'object') {
								if (cookies[notificationName]) cookieIsSet = true;
							} else if (cookies) {
								cookies.split(';').forEach((cookie) => {
									// Cookie is set don't display notification.
									if (cookie.indexOf(notificationName) !== -1) cookieIsSet = true;
								});
							}

							// Item shown already.
							if (cookieIsSet && item.removed !== true) return null;
							// Item delayed don't show yet.
							if (item.delay && !delay[notificationName]) return null;
							*/

							notificationAttributes['data-name'] = notificationName;
							notificationAttributes['data-duration'] = item.cookieDuration;
						}

						const innerText = translate(setup, item.text);
						const innerContent = item.content && item.content.filter((c) => {
							if (c.countryRestrictContent && isRestricted(setup, { selectedCountries: c.countryRestrictContent })) return false;
							if (c.customRestrictContent && c.customRestrictContent !== setup.campaignType) return false;
							if (!c.text && !c.icon) return false;
							return true;
						});

						return (
							<Transition in={item.removed !== true} timeout={300} key={notificationName} unmountOnExit>
								{(state) => (
									<>
										{ type === 'popup' && <button className={[s.notification_inner_screen, (showPopup ? s.notification_inner_screen__showing : null)].join(' ')} type="button" aria-label="Close popup" /> }
										<div ref={this.notificationInner} className={[...notificationInnerClasses, (showPopup ? s.notification_inner__showing : null), (showVoucher ? s.notification_inner__showingVoucher : null), s[`notification_inner__${state}`]].join(' ')} {...notificationAttributes}>
											{ item.title && <button className={s.notification_inner_title} type="button" onClick={this.togglePopupHandler}>{ translate(setup, item.title) }</button> }
											{
												innerContent && (
													<div ref={this.notificationInnerContent} className={s.notification_inner_items}>
														<div>
															{
																innerContent.map((c) => {
																	const tempInnerText = translate(setup, c.text);
																	const innerContentReturn = [];
																	if (c.icon) innerContentReturn.push(<img className={s.notification_inner_item_icon} src={c.icon.url} alt={c.icon.alt} />);
																	if (tempInnerText && /trustpilot/i.test(tempInnerText)) innerContentReturn.push(<TrustBox content={{ templateCode: tempInnerText }} />);
																	else if (tempInnerText) innerContentReturn.push(<span className={s.notification_inner_item_text} dangerouslySetInnerHTML={{ __html: purifier(tempInnerText.replace('%country%', setup.countries[setup.country].name)) }} />);
																	return <div className={s.notification_inner_item}>{ innerContentReturn }</div>;
																})
															}
														</div>
													</div>
												)
											}
											{ innerText && /trustpilot/i.test(innerText) && <TrustBox content={{ templateCode: innerText }} /> }
											{ innerText && !/trustpilot/i.test(innerText) && <span className={s.notification_inner_text} dangerouslySetInnerHTML={{ __html: purifier(innerText.replace('%country%', setup.countries[setup.country].name)) }} /> }
											{
												item.removable && item.cookieDuration && (
													<a className={s.notification_inner_close} href="#close" ref={this.notificationClose} onClick={this.removeNotificationHandler}>
														{
															item.removeText ? translate(setup, item.removeText) : (
																<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
																	<g strokeLinecap="round">
																		<path stroke="#FFF" d="M1.5 2L15.229 15.729M1.5 15.7285L15.229 1.9995" />
																	</g>
																</svg>
															)
														}
													</a>
												)
											}
											{
												type === 'popup' && (
													<button className={s.notification_inner_toggle} type="button" onClick={this.togglePopupHandler} aria-label="Toggle Popup" />
												)
											}
											<div className={s.notification_inner_footer}>
												{ item.includeNewsletter && <Newsletter callback={this.newsletterSubmitHandler} isPopup /> }
												{
													!showVoucher && item.voucher && (
														<div className={s.notification_inner_footer_voucher}>
															<span className={s.notification_inner_footer_voucher_code}>{ translate(setup, 'newsletterVoucherReveal') }</span>
														</div>
													)
												}
												{
													showVoucher && item.voucher && (
														<div className={s.notification_inner_footer_voucher}>
															<span className={s.notification_inner_footer_voucher_code}>{ item.voucher }</span>
															<Button type="button" clickEventHandler={this.copyToClipboard} value={item.voucher}>{ copied ? translate(setup, 'newsletterCopiedCode') : translate(setup, 'newsletterCopyCode') }</Button>
														</div>
													)
												}
												{
													showVoucher && item.voucher && (
														<div className={s.notification_inner_footer_disclaimer}>
															{ translate(setup, 'newsletterVoucherDisclaimer') }
														</div>
													)
												}
											</div>
										</div>
									</>
								)}
							</Transition>
						);
					})
				}
			</div>
		);
	}
}

export default hot(module)(Notification);
